import { StandardFile } from '../shared/file/file';

export class ReferDetails {
    first_name: string;
    last_name: string;
    mobile_no: number;
    mobile_no_cc: number;
    email_id: string;
    resume_document: StandardFile;

    constructor(obj = {
        first_name: '',
        last_name: '',
        mobile_no: null,
        mobile_no_cc: 0,
        email_id: '',
        resume_document: null,

    }) {
        if (obj.resume_document && typeof obj.resume_document == "string" && obj.resume_document != 'null') {
            obj.resume_document = JSON.parse(obj.resume_document);
        }
        else if (obj.resume_document == '' || obj.resume_document == 'null') {
            obj.resume_document = null;
        }
        this.resume_document = obj.resume_document || null;
        this.first_name = obj.first_name || '';
        this.last_name = obj.last_name || '';
        this.mobile_no = obj.mobile_no || '';
        this.mobile_no_cc = obj.mobile_no_cc || 1000;
        this.email_id = obj.email_id || '';

    }
    setFormGroupData(obj) {
        this.first_name = obj.first_name || '';
        this.last_name = obj.last_name || '';
        this.mobile_no = obj.mobile_no || '';
        this.mobile_no_cc = obj.mobile_no_cc || 1000;
        this.email_id = obj.email_id || '';

    }
    setData(obj) {
        this.first_name = obj.first_name || '';
        this.last_name = obj.last_name || '';
        this.mobile_no = obj.mobile_no || '';
        this.mobile_no_cc = obj.mobile_no_cc || 1000;
        this.email_id = obj.email_id || '';
        if (obj.resume_document && typeof obj.resume_document == "string" && obj.resume_document != 'null') {
            obj.resume_document = JSON.parse(obj.resume_document);
        }
        else if (obj.resume_document == '' || obj.resume_document == 'null') {
            obj.resume_document = null;
        }
        this.resume_document = obj.resume_document || null;

    }
    getFormGroupData() {
        return {
            first_name: this.first_name || '',
            last_name: this.last_name || '',
            mobile_no: this.mobile_no || '',
            mobile_no_cc: this.mobile_no_cc || 1000,
            email_id: this.email_id || '',

        }
    }

    setFile(obj) {
        if (obj.Name) {
            this.first_name = obj.Name;
        }
        if (obj.EMail) {
            this.email_id = obj.EMail;
        }
        if (obj.Mobile) {
            this.mobile_no = obj.Mobile;
        }
        this.mobile_no_cc = 1000;

    }


}